import styled from 'styled-components'
import { Skeleton } from '@material-ui/lab'

export const Root = styled(Skeleton)`
  &.MuiSkeleton-root {
    background-color: ${props => props.theme.palette.gray[90]};
    border-radius: 3px;
    display: inline-block;
    margin: ${props => props.margin};
    opacity: 0.1;
    padding: ${props => props.padding};
    width: ${props => props.width || '100%'};
  }

  &.MuiSkeleton-rect,
  &.MuiSkeleton-text {
    border-radius: 3px;
  }

  &.MuiSkeleton-circle {
    border-radius: 50%;
  }
`
